import {
  PerfilFuncional,
  DashboardComandoGeral,
  IndicadoresUnidade,
  AlertaMapaForca,
  EfetivoUnidade,
} from '../models/mapa-forca.models';

/** G3: Nomes e graduações para geração de policiais pendentes de validação (extraídos do componente) */
export const MOCK_NOMES_PENDENTES = [
  'SGT ALVES', 'CB COSTA', 'SD SOUZA', 'SGT DIAS', 'CB BATISTA',
  'SD GOMES', 'SGT NEVES', 'CB LOPES', 'SD MARTINS', 'SGT SILVA', 'CB OLIVEIRA'
];

export const MOCK_GRADUACOES_PENDENTES = [
  '3º SARGENTO', 'CABO', 'SOLDADO', '2º SARGENTO', 'CABO',
  'SOLDADO', '3º SARGENTO', 'CABO', 'SOLDADO', '1º SARGENTO', 'CABO'
];

export const MOCK_POLICIAIS: PerfilFuncional[] = [
  {
    matricula: '18.2639.42',
    nomeGuerra: 'SGT MARCOS',
    nomeCompleto: 'Marcos Santos da Silva',
    postoGraduacao: '3º SARGENTO',
    quadroCarreira: 'QPPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Comandante de Guarnição',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'DISPONIVEL_OPERACIONAL',
    situacoesAtivas: [],
    habilitacoes: [
      {
        codigoCurso: 'MOT-A',
        nomeCurso: 'Habilitação de Motociclista Militar - Categoria A',
        categoriaHabilitacao: 'ESPECIALIZACAO_OPERACIONAL',
        dataConclusao: '2023-04-12',
        dataValidade: '2028-04-12',
        necessitaReciclagem: false,
        situacaoCertificado: 'VALIDO',
        nivelProficiencia: 'AVANCADO',
      },
      {
        codigoCurso: 'APH',
        nomeCurso: 'Atendimento Pré-Hospitalar Tático (APHT)',
        categoriaHabilitacao: 'HABILITACAO_TECNICA',
        dataConclusao: '2024-08-15',
        dataValidade: '2027-08-15',
        necessitaReciclagem: false,
        situacaoCertificado: 'VALIDO',
        nivelProficiencia: 'INTERMEDIARIO',
      },
    ],
    identificacaoCivil: {
      cpf: '01234567890',
      dataNascimento: '1988-05-14',
      sexo: 'MASCULINO',
      emailInstitucional: 'marcos.silva@pm.df.gov.br',
      telefoneInstitucional: '(61) 99123-4567',
    },
    dadosCarreira: {
      dataIngresso: '2010-02-18',
      antiguidade: 142,
      turma: 'CFSD II/2010',
      comportamento: 'Excepcional',
    },
    atualizadoEm: '2026-06-15T16:00:00Z',
    fontesAtualizacao: ['cadastro', 'capacitacao'],
  },
  {
    matricula: '20.1852.19',
    nomeGuerra: 'CB ALINE',
    nomeCompleto: 'Aline Oliveira Sousa',
    postoGraduacao: 'CABO',
    quadroCarreira: 'QPPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Auxiliar Administrativo',
    vinculoOperacional: 'ATIVIDADE_MEIO',
    disponibilidadeOperacional: 'DISPONIVEL_COM_RESTRICAO',
    situacoesAtivas: [
      {
        tipo: 'RESTRICAO_MEDICA',
        categoria: 'RESTRICAO_PARCIAL',
        tipoRestricaoOperacional: 'SEM_SERVICO_EXTERNO',
        grauRestricao: 'PARCIAL',
        impactoNaEscala: 'PERMITE_FUNCAO_ADMINISTRATIVA',
        dataInicio: '2026-05-01',
        dataFim: '2026-07-01',
        impactoOperacional: true,
      },
    ],
    habilitacoes: [
      {
        codigoCurso: 'APH',
        nomeCurso: 'Atendimento Pré-Hospitalar Tático (APHT)',
        categoriaHabilitacao: 'HABILITACAO_TECNICA',
        dataConclusao: '2023-01-20',
        dataValidade: '2026-01-20',
        necessitaReciclagem: true,
        situacaoCertificado: 'VENCIDO',
        nivelProficiencia: 'BASICO',
      },
    ],
    identificacaoCivil: {
      cpf: '98765432109',
      dataNascimento: '1992-10-22',
      sexo: 'FEMININO',
      emailInstitucional: 'aline.sousa@pm.df.gov.br',
      telefoneInstitucional: '(61) 98223-1122',
    },
    dadosCarreira: {
      dataIngresso: '2014-06-10',
      antiguidade: 88,
      turma: 'CFSD I/2014',
      comportamento: 'Ótimo',
    },
    atualizadoEm: '2026-06-15T15:30:00Z',
    fontesAtualizacao: ['cadastro', 'pericia-medica', 'capacitacao'],
  },
  {
    matricula: '15.9876.54',
    nomeGuerra: 'MAJ ROBERTO',
    nomeCompleto: 'Roberto de Souza Carvalho',
    postoGraduacao: 'MAJOR',
    quadroCarreira: 'QOPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Subcomandante de Batalhão',
    vinculoOperacional: 'ATIVIDADE_MEIO',
    disponibilidadeOperacional: 'INDISPONIVEL_TEMPORARIO',
    situacoesAtivas: [
      {
        tipo: 'AFASTAMENTO',
        categoria: 'FERIAS',
        dataInicio: '2026-06-01',
        dataFim: '2026-06-30',
        impactoOperacional: true,
      },
    ],
    habilitacoes: [],
    identificacaoCivil: {
      cpf: '45612378933',
      dataNascimento: '1979-12-05',
      sexo: 'MASCULINO',
      emailInstitucional: 'roberto.carvalho@pm.df.gov.br',
      telefoneInstitucional: '(61) 99344-8899',
    },
    dadosCarreira: {
      dataIngresso: '2002-01-15',
      antiguidade: 12,
      turma: 'CFO/2002',
      comportamento: 'Excepcional',
    },
    atualizadoEm: '2026-06-15T12:00:00Z',
    fontesAtualizacao: ['cadastro', 'afastamento'],
  },
  {
    matricula: '19.4521.88',
    nomeGuerra: 'CAP JULIA',
    nomeCompleto: 'Julia Lima Vasconcelos',
    postoGraduacao: 'CAPITÃO',
    quadroCarreira: 'QOPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Comandante de Companhia',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'INDISPONIVEL_MEDICO',
    situacoesAtivas: [
      {
        tipo: 'RESTRICAO_MEDICA',
        categoria: 'LICENCA_TRATAMENTO_SAUDE',
        tipoRestricaoOperacional: 'SEM_SERVICO_ATIVO',
        grauRestricao: 'IMPEDITIVA',
        impactoNaEscala: 'BLOQUEIA_ESCALA_OPERACIONAL',
        dataInicio: '2026-06-10',
        dataFim: '2026-06-25',
        impactoOperacional: true,
      },
    ],
    habilitacoes: [
      {
        codigoCurso: 'CHOQUE',
        nomeCurso: 'Curso de Especialização em Policiamento de Choque',
        categoriaHabilitacao: 'ESPECIALIZACAO_OPERACIONAL',
        dataConclusao: '2020-11-20',
        dataValidade: null,
        necessitaReciclagem: false,
        situacaoCertificado: 'VALIDO',
        nivelProficiencia: 'MULTIPLICADOR',
      },
    ],
    identificacaoCivil: {
      cpf: '78912345688',
      dataNascimento: '1984-04-03',
      sexo: 'FEMININO',
      emailInstitucional: 'julia.vasconcelos@pm.df.gov.br',
      telefoneInstitucional: '(61) 98111-2233',
    },
    dadosCarreira: {
      dataIngresso: '2007-02-01',
      antiguidade: 35,
      turma: 'CFO/2007',
      comportamento: 'Excepcional',
    },
    atualizadoEm: '2026-06-15T10:00:00Z',
    fontesAtualizacao: ['cadastro', 'pericia-medica', 'capacitacao'],
  },
  {
    matricula: '24.9921.04',
    nomeGuerra: 'SD CARLOS',
    nomeCompleto: 'Carlos Neves Pinheiro',
    postoGraduacao: 'SOLDADO',
    quadroCarreira: 'QPPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Radiopatrulheiro',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'PENDENTE_VALIDACAO',
    situacoesAtivas: [],
    habilitacoes: [],
    identificacaoCivil: {
      cpf: '32165498701',
      dataNascimento: '1997-08-29',
      sexo: 'MASCULINO',
      emailInstitucional: 'carlos.pinheiro@pm.df.gov.br',
      telefoneInstitucional: '(61) 99554-3322',
    },
    dadosCarreira: {
      dataIngresso: '2024-01-10',
      antiguidade: 210,
      turma: 'CFSD I/2024',
      comportamento: 'Bom',
    },
    atualizadoEm: '2026-06-15T09:00:00Z',
    fontesAtualizacao: ['cadastro'],
  },
  {
    matricula: '12.3344.55',
    nomeGuerra: 'TC RODRIGO',
    nomeCompleto: 'Rodrigo Augusto Silva',
    postoGraduacao: 'TENENTE CORONEL',
    quadroCarreira: 'QOPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-CG',
    nomeUnidade: 'Comando-Geral',
    comandoIntermediario: 'CG',
    funcaoNaUnidade: 'Chefe de Gabinete',
    vinculoOperacional: 'ATIVIDADE_MEIO',
    disponibilidadeOperacional: 'AGREGADO_CEDIDO',
    situacoesAtivas: [
      {
        tipo: 'AFASTAMENTO',
        categoria: 'CESSÃO',
        dataInicio: '2025-01-01',
        dataFim: '2027-01-01',
        impactoOperacional: true,
      },
    ],
    habilitacoes: [],
    identificacaoCivil: {
      cpf: '11122233344',
      dataNascimento: '1976-03-11',
      sexo: 'MASCULINO',
      emailInstitucional: 'rodrigo.silva@pm.df.gov.br',
      telefoneInstitucional: '(61) 98999-0000',
    },
    dadosCarreira: {
      dataIngresso: '1998-02-15',
      antiguidade: 5,
      turma: 'CFO/1998',
      comportamento: 'Excepcional',
    },
    atualizadoEm: '2026-06-15T08:00:00Z',
    fontesAtualizacao: ['cadastro', 'afastamento'],
  },
  {
    matricula: '17.4421.32',
    nomeGuerra: 'SGT ROCHA',
    nomeCompleto: 'Daniel Rocha Faria',
    postoGraduacao: '2º SARGENTO',
    quadroCarreira: 'QPPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-2BPM',
    nomeUnidade: '2º Batalhão de Polícia Militar (Taguatinga)',
    comandoIntermediario: 'CPBN',
    funcaoNaUnidade: 'Supervisor de Dia',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'EMPREGADO',
    situacoesAtivas: [],
    habilitacoes: [
      {
        codigoCurso: 'MOT-A',
        nomeCurso: 'Habilitação de Motociclista Militar - Categoria A',
        categoriaHabilitacao: 'ESPECIALIZACAO_OPERACIONAL',
        dataConclusao: '2021-05-15',
        dataValidade: '2026-05-15',
        necessitaReciclagem: true,
        situacaoCertificado: 'VENCIDO',
        nivelProficiencia: 'INTERMEDIARIO',
      },
    ],
    identificacaoCivil: {
      cpf: '74185296311',
      dataNascimento: '1986-11-30',
      sexo: 'MASCULINO',
      emailInstitucional: 'daniel.faria@pm.df.gov.br',
      telefoneInstitucional: '(61) 99188-4455',
    },
    dadosCarreira: {
      dataIngresso: '2008-08-10',
      antiguidade: 95,
      turma: 'CFSD II/2008',
      comportamento: 'Excepcional',
    },
    atualizadoEm: '2026-06-15T14:00:00Z',
    fontesAtualizacao: ['cadastro', 'capacitacao'],
  },
  {
    matricula: '21.5543.88',
    nomeGuerra: 'SGT FERNANDA',
    nomeCompleto: 'Fernanda Costa Medeiros',
    postoGraduacao: '3º SARGENTO',
    quadroCarreira: 'QPPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-2BPM',
    nomeUnidade: '2º Batalhão de Polícia Militar (Taguatinga)',
    comandoIntermediario: 'CPBN',
    funcaoNaUnidade: 'Operadora de COPOM',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'SOBREAVISO',
    situacoesAtivas: [],
    habilitacoes: [
      {
        codigoCurso: 'BOPE',
        nomeCurso: 'Curso de Operações Especiais (COEsp)',
        categoriaHabilitacao: 'ESPECIALIZACAO_OPERACIONAL',
        dataConclusao: '2022-10-10',
        dataValidade: null,
        necessitaReciclagem: false,
        situacaoCertificado: 'VALIDO',
        nivelProficiencia: 'BASICO',
      },
    ],
    identificacaoCivil: {
      cpf: '12398745677',
      dataNascimento: '1993-01-18',
      sexo: 'FEMININO',
      emailInstitucional: 'fernanda.medeiros@pm.df.gov.br',
      telefoneInstitucional: '(61) 99222-3344',
    },
    dadosCarreira: {
      dataIngresso: '2015-02-18',
      antiguidade: 110,
      turma: 'CFSD I/2015',
      comportamento: 'Ótimo',
    },
    atualizadoEm: '2026-06-15T15:00:00Z',
    fontesAtualizacao: ['cadastro', 'capacitacao'],
  },
  {
    matricula: '19.8821.11',
    nomeGuerra: 'TEN ALBUQUERQUE',
    nomeCompleto: 'Thiago Albuquerque Melo',
    postoGraduacao: '2º TENENTE',
    quadroCarreira: 'QOPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Comandante de Pelotão',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'DISPONIVEL_COM_RESTRICAO',
    situacoesAtivas: [
      {
        tipo: 'RESTRICAO_MEDICA',
        categoria: 'RESTRICAO_PARCIAL',
        tipoRestricaoOperacional: 'SEM_ESFORCO_FISICO',
        grauRestricao: 'PARCIAL',
        impactoNaEscala: 'PERMITE_EXPEDIENTE',
        dataInicio: '2026-06-10',
        dataFim: '2026-06-20',
        impactoOperacional: true,
      },
    ],
    habilitacoes: [],
    identificacaoCivil: {
      cpf: '45678912300',
      dataNascimento: '1988-09-09',
      sexo: 'MASCULINO',
      emailInstitucional: 'thiago.melo@pm.df.gov.br',
      telefoneInstitucional: '(61) 98888-2233',
    },
    dadosCarreira: {
      dataIngresso: '2011-02-01',
      antiguidade: 28,
      turma: 'CFO/2011',
      comportamento: 'Excepcional',
    },
    atualizadoEm: '2026-06-15T15:45:00Z',
    fontesAtualizacao: ['cadastro', 'pericia-medica'],
  },
  {
    matricula: '22.3394.02',
    nomeGuerra: 'SD MARTINS',
    nomeCompleto: 'Gabriel Martins Santos',
    postoGraduacao: 'SOLDADO',
    quadroCarreira: 'QPPM',
    situacaoFuncional: 'ATIVO',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
    comandoIntermediario: 'CPRL',
    funcaoNaUnidade: 'Radiopatrulheiro',
    vinculoOperacional: 'ATIVIDADE_FIM',
    disponibilidadeOperacional: 'DISPONIVEL_OPERACIONAL',
    situacoesAtivas: [],
    habilitacoes: [
      {
        codigoCurso: 'APH',
        nomeCurso: 'Atendimento Pré-Hospitalar Tático (APHT)',
        categoriaHabilitacao: 'HABILITACAO_TECNICA',
        dataConclusao: '2024-11-10',
        dataValidade: '2027-11-10',
        necessitaReciclagem: false,
        situacaoCertificado: 'VALIDO',
        nivelProficiencia: 'BASICO',
      },
    ],
    identificacaoCivil: {
      cpf: '88877766655',
      dataNascimento: '1995-12-15',
      sexo: 'MASCULINO',
      emailInstitucional: 'gabriel.santos@pm.df.gov.br',
      telefoneInstitucional: '(61) 99111-9988',
    },
    dadosCarreira: {
      dataIngresso: '2022-01-10',
      antiguidade: 140,
      turma: 'CFSD I/2022',
      comportamento: 'Bom',
    },
    atualizadoEm: '2026-06-15T16:05:00Z',
    fontesAtualizacao: ['cadastro', 'capacitacao'],
  },
];

export const MOCK_INDICADORES_1BPM: IndicadoresUnidade = {
  idUnidade: 'UND-1BPM',
  nomeUnidade: '1º Batalhão de Polícia Militar (Asa Sul)',
  efetivoPrevisto: 320,
  efetivoExistente: 298,
  efetivoDisponivel: 246,
  deficitNominal: 22,
  deficitOperacional: -22,
  taxaProntidao: 0.824,
  taxaIndisponibilidade: 0.176,
  taxaRestricaoMedica: 0.081,
  atualizadoEm: '2026-06-15T16:10:00Z',
};

export const MOCK_EFETIVO_AGREGADO_1BPM: EfetivoUnidade[] = [
  {
    idUnidade: 'UND-1BPM',
    postoGraduacao: 'MAJOR',
    quadroCarreira: 'QOPM',
    previsto: 3,
    existente: 2,
    disponiveis: 1,
    comRestricao: 0,
    indisponiveis: 1,
    agregadosCedidos: 0,
    pendenteValidacao: 0,
    claros: 1,
    excessos: 0,
    atualizadoEm: '2026-06-15T16:10:00Z',
  },
  {
    idUnidade: 'UND-1BPM',
    postoGraduacao: 'CAPITÃO',
    quadroCarreira: 'QOPM',
    previsto: 8,
    existente: 7,
    disponiveis: 5,
    comRestricao: 0,
    indisponiveis: 2,
    agregadosCedidos: 0,
    pendenteValidacao: 0,
    claros: 1,
    excessos: 0,
    atualizadoEm: '2026-06-15T16:10:00Z',
  },
  {
    idUnidade: 'UND-1BPM',
    postoGraduacao: '2º TENENTE',
    quadroCarreira: 'QOPM',
    previsto: 12,
    existente: 11,
    disponiveis: 8,
    comRestricao: 2,
    indisponiveis: 1,
    agregadosCedidos: 0,
    pendenteValidacao: 0,
    claros: 1,
    excessos: 0,
    atualizadoEm: '2026-06-15T16:10:00Z',
  },
  {
    idUnidade: 'UND-1BPM',
    postoGraduacao: '3º SARGENTO',
    quadroCarreira: 'QPPM',
    previsto: 60,
    existente: 58,
    disponiveis: 46,
    comRestricao: 4,
    indisponiveis: 6,
    agregadosCedidos: 1,
    pendenteValidacao: 1,
    claros: 2,
    excessos: 0,
    atualizadoEm: '2026-06-15T16:10:00Z',
  },
  {
    idUnidade: 'UND-1BPM',
    postoGraduacao: 'CABO',
    quadroCarreira: 'QPPM',
    previsto: 80,
    existente: 82,
    disponiveis: 65,
    comRestricao: 8,
    indisponiveis: 7,
    agregadosCedidos: 0,
    pendenteValidacao: 2,
    claros: 0,
    excessos: 2,
    atualizadoEm: '2026-06-15T16:10:00Z',
  },
  {
    idUnidade: 'UND-1BPM',
    postoGraduacao: 'SOLDADO',
    quadroCarreira: 'QPPM',
    previsto: 157,
    existente: 138,
    disponiveis: 110,
    comRestricao: 10,
    indisponiveis: 13,
    agregadosCedidos: 2,
    pendenteValidacao: 3,
    claros: 19,
    excessos: 0,
    atualizadoEm: '2026-06-15T16:10:00Z',
  },
];

export const MOCK_ALERTAS: AlertaMapaForca[] = [
  {
    id: 'alert-1',
    tipo: 'PRONTIDAO_CRITICA',
    severidade: 'CRITICA',
    idUnidade: 'UND-5BPM',
    nomeUnidade: '5º Batalhão de Polícia Militar',
    descricao: 'A taxa de prontidão da unidade caiu para 58.2% (limiar crítico < 60%).',
    geradoEm: '2026-06-15T08:30:00Z',
    ativo: true,
  },
  {
    id: 'alert-2',
    tipo: 'RESTRICAO_INCOMPATIVEL',
    severidade: 'ALTA',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar',
    matricula: '20.1852.19',
    nomeGuerra: 'CB ALINE',
    descricao: 'Militar escalada em policiamento externo ativo apesar de possuir restrição de SEM_SERVICO_EXTERNO.',
    geradoEm: '2026-06-15T10:15:00Z',
    ativo: true,
  },
  {
    id: 'alert-3',
    tipo: 'HABILITACAO_VENCENDO',
    severidade: 'MEDIA',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar',
    matricula: '17.4421.32',
    nomeGuerra: 'SGT ROCHA',
    descricao: 'A habilitação MOT-A está próxima do vencimento (restam menos de 30 dias).',
    geradoEm: '2026-06-14T07:00:00Z',
    ativo: true,
  },
  {
    id: 'alert-4',
    tipo: 'DADO_INCONSISTENTE',
    severidade: 'BAIXA',
    idUnidade: 'UND-1BPM',
    nomeUnidade: '1º Batalhão de Polícia Militar',
    matricula: '24.9921.04',
    nomeGuerra: 'SD CARLOS',
    descricao: 'Militar com dados cadastrais sem confirmação periódica da UPM (PENDENTE_VALIDACAO).',
    geradoEm: '2026-06-15T06:00:00Z',
    ativo: true,
  },
];

export const MOCK_DASHBOARD_GLOBAL: DashboardComandoGeral = {
  efetivoTotal: 12543,
  taxaProntidaoGeral: 0.796,
  deficitOperacionalGeral: 18.4,
  alertasCriticosContagem: 7,
  efetivoPorComandoIntermediario: [
    {
      comandoIntermediario: 'CPRL',
      existente: 5000,
      disponivel: 4265,
      taxaProntidao: 0.853,
    },
    {
      comandoIntermediario: 'CPRM',
      existente: 4500,
      disponivel: 3515,
      taxaProntidao: 0.781,
    },
    {
      comandoIntermediario: 'CPC',
      existente: 4800,
      disponivel: 3581,
      taxaProntidao: 0.746,
    },
    {
      comandoIntermediario: 'CPChq',
      existente: 2500,
      disponivel: 1705,
      taxaProntidao: 0.682,
    },
    {
      comandoIntermediario: 'CPBn',
      existente: 3600,
      disponivel: 2606,
      taxaProntidao: 0.724,
    },
  ],
  indisponibilidadesPorTipo: [
    {
      tipo: 'Férias',
      quantidade: 1245,
      percentual: 45.6,
    },
    {
      tipo: 'Licenças',
      quantidade: 764,
      percentual: 28.7,
    },
    {
      tipo: 'Médico',
      quantidade: 418,
      percentual: 15.3,
    },
    {
      tipo: 'Disciplinar',
      quantidade: 185,
      percentual: 6.8,
    },
    {
      tipo: 'Outros',
      quantidade: 98,
      percentual: 3.6,
    },
  ],
  unidadesComDeficitCritico: [
    {
      idUnidade: 'UND-1BPM',
      nomeUnidade: '1º BPM',
      previsto: 440,
      existente: 320,
      disponivel: 298,
      deficitOperacional: 120,
      taxaProntidao: 0.621,
    },
    {
      idUnidade: 'UND-8BPM',
      nomeUnidade: '8º BPM',
      previsto: 386,
      existente: 291,
      disponivel: 254,
      deficitOperacional: 95,
      taxaProntidao: 0.652,
    },
    {
      idUnidade: 'UND-11BPM',
      nomeUnidade: '11º BPM',
      previsto: 398,
      existente: 310,
      disponivel: 242,
      deficitOperacional: 88,
      taxaProntidao: 0.648,
    },
    {
      idUnidade: 'UND-BPCAES',
      nomeUnidade: 'BPCães',
      previsto: 200,
      existente: 158,
      disponivel: 132,
      deficitOperacional: 42,
      taxaProntidao: 0.663,
    },
    {
      idUnidade: 'UND-BPCHOQUE',
      nomeUnidade: 'BPChoque',
      previsto: 195,
      existente: 157,
      disponivel: 135,
      deficitOperacional: 38,
      taxaProntidao: 0.678,
    },
  ],
  especialidadesCriticasEscassas: [
    {
      codigoCurso: 'CHOQUE',
      nomeCurso: 'CHOQUE',
      quantidadeTotal: 180,
      quantidadeDisponivel: 120,
      coberturaPercentual: 66.7,
    },
    {
      codigoCurso: 'APH Tático',
      nomeCurso: 'APH Tático',
      quantidadeTotal: 120,
      quantidadeDisponivel: 85,
      coberturaPercentual: 70.8,
    },
    {
      codigoCurso: 'Pilotagem Operacional',
      nomeCurso: 'Pilotagem Operacional',
      quantidadeTotal: 60,
      quantidadeDisponivel: 42,
      coberturaPercentual: 70.0,
    },
    {
      codigoCurso: 'Tiro de Precisão',
      nomeCurso: 'Tiro de Precisão',
      quantidadeTotal: 40,
      quantidadeDisponivel: 28,
      coberturaPercentual: 70.0,
    },
    {
      codigoCurso: 'Operações com Cães',
      nomeCurso: 'Operações com Cães',
      quantidadeTotal: 50,
      quantidadeDisponivel: 35,
      coberturaPercentual: 70.0,
    },
  ],
  freshness: '2026-06-15T16:11:00Z',
};
